import { Provider } from 'react-redux';
import App from './App';
import store from './store';
import { useEffect } from 'react';
import useMediaSession from '../hooks/useMediaSession';
import { BASE_TIMER_TIME } from '../utilities/Constants';

export default function Root() {
  useMediaSession();
  useEffect(() => {
    window.localStorage.setItem('LastSetTime', BASE_TIMER_TIME.toString());
  }, []);

  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
}
